import { AxiosError } from 'axios';

interface ApiErrorData {
  message?: string;
  debugMessage?: string;
  body?: string;
  requestUrl?: string;
}

const stripQuotes = (s: string) => s.replace(/^"|"$/g, '');

export const getApiErrorMessage = (error: unknown): string => {
  if (error instanceof AxiosError) {
    const data = (error.response?.data as ApiErrorData) ?? {};
    const msg =
      data.debugMessage?.trim() ?? data.body?.trim() ?? data.message?.trim();
    if (msg) return stripQuotes(msg);
  }
  return error instanceof Error ? error.message : 'An unexpected error occurred';
};

export const required = (field: string): string => {
  return `${field} is required`;
};

export const min = (field: string, min: number): string => {
  return `${field} field must contain at least ${min} characters`;
};

export const positive = (field: string): string => {
  return `${field} must be a positive number`;
};

export const integer = (field: string): string => {
  return `${field} must be a whole number`;
};

export const errorResponse = (error: AxiosError) => {
  const responseData = error.response?.data as { message?: string };
  let errorMessage = responseData?.message || 'An unexpected error occurred';
  return errorMessage.replace(/^"|"$/g, '');
};
